import React from "react";
import { bind } from "decko";
import $ from "jquery";

import GenericBlackBtn from "./GenericBlackBtn";
import Analytics from "./include/Analytics";

export default class PlaybackRateControls extends React.Component {
    constructor (props) {
        super(props);

        //tickFrequency determines frames per second while seeking
        this.tickFrequency = 5;
        //FIXME: Preferable to have variable tickFrequency, as higher fps would be good when seeking slowly
        //and lower fps is acceptable (and required, as it takes longer to process) when seeking very fast.
        //FIXME: Additional problems occur when we set video.currentTime outside bounds of video.buffered,
        //this triggers network calls etc and we typically don't manage to update at 5 fps.

        this.ticksSinceLastSeek = 0;

        this.state = {
            playbackRate: 1,
            isSeeking: false,
            autoCatchup: props.startInCatchupMode,
        };

        this.hotkeys = {
            "b": this.toggleAutoCatchup,

            "q": () => this.shuttleProSeek(-14.0),
            "w": () => this.shuttleProSeek(-6.0 ),
            "e": () => this.shuttleProSeek(-2.5 ),
            "r": () => this.shuttleProSeek(-1.2 ),
            "t": () => this.shuttleProSeek(-0.6 ),
            "y": () => this.shuttleProSeek(-0.2 ),
            "u": () => this.shuttleProSeek( 0   ),

            "i": this.endSeeking,

            "a": () => this.shuttleProSeek(1.25),
            "s": () => this.shuttleProSeek(1.75),
            "d": () => this.shuttleProSeek(2.5 ),
            "f": () => this.shuttleProSeek(3.75),
            "g": () => this.shuttleProSeek(5.0 ),
            "h": () => this.shuttleProSeek(8.0 ),
            "j": () => this.shuttleProSeek(14.0),

            // Fix a bug where the seeking gets stuck when swapping between windows
            "loseFocus": this.resetShuttleProSeeking,
        };
    }

    componentDidMount () {
        this.tickInterval = setInterval(this.tick, 1000/this.tickFrequency);
        this.analyticsTickInterval = setInterval(this.analyticsTick, 1000);
        if (this.state.autoCatchup) {
            this.setVideoPlaybackRate(1.2);//Browser tends to buffer a little bit longer than we want at start
        }
        this.props.hotkeyHandler.subscribe(this.hotkeys, this);
    }

    componentWillUnmount () {
        clearInterval(this.tickInterval);
        clearInterval(this.analyticsTickInterval);
        this.props.hotkeyHandler.unsubscribe(this.hotkeys, this);
    }

    @bind
    analyticsTick () {
        const currentTime = Math.max(0, this.props.video.currentTime); //Quirk may occur at start of stream
        const timeBehindLive = this.props.video.duration - currentTime;
        if (!this.props.paused && !isNaN(timeBehindLive)) {
            Analytics.streamEvent(this.props.stream, "tick", {
                playback_rate: this.state.playbackRate,
                behind_live: timeBehindLive,
                duration: currentTime,
                is_seeking: this.state.isSeeking,
            });
        }
    }

    @bind
    resetShuttleProSeeking () {
        this.endSeeking();
        return false; //Important to return false, to allow the event to propagate
    }

    @bind
    toggleAutoCatchup () {
        let auto = !this.state.autoCatchup;

        if (!auto) this.setVideoPlaybackRate(1);

        this.setState({autoCatchup: auto});
    }

    shuttleProSeek (playbackRate) {
        this.props.video.playbackRate = 0;
        this.setState({isSeeking: true, playbackRate: playbackRate});
    }

    calculatePlaybackRate (position) {
        /* input range  : [0 .. 1]
         * output range : [-16 .. 16]
         * Perform a sineEaseIn acceleration function, based on http://gizma.com/easing/#sin1
         * The sineEaseIn function ignores sign and outputs [0 .. 16]
         * If position was less than 0.5, output should be negative
         */
        position -= 0.5; // Move into [-0.5..0.5] range
        const rate = 16 - 16 * Math.cos(position * Math.PI);
        return (position < 0) ? rate * -1 : rate;
    }

    calculatePlaybackMarkerPosition (playbackRate) {
        /* input range  : [-16 .. 16]
         * output range : [0 .. 1]
         * Inverse of calculatePlaybackRate
         */
        let sign = playbackRate < 0 ? -1 : 1;
        return sign * (Math.acos((16-Math.abs(playbackRate))/16)/Math.PI + 0.5*sign);
    }

    setVideoPlaybackRate (rate) {
        this.props.video.playbackRate = rate;
        this.setState({playbackRate: rate});
    }

    catchUpToLive (timeBehindLive) {
        if (this.state.playbackRate < 1.1) {
            Analytics.streamEvent(this.props.stream, "catchup", {
                behind_live: timeBehindLive,
            });
        }
        const newPlaybackRate = 1 + Math.log10(timeBehindLive / this.props.avrgBufferDuration+1);
        this.setVideoPlaybackRate(Math.min(newPlaybackRate, 3));
    }

    shouldStartLiveCatchup () {
        if (!this.state.autoCatchup) return false;

        const timeSinceLastSeek = this.ticksSinceLastSeek / this.tickFrequency;
        if (timeSinceLastSeek < 1.5) return false;

        const currentTime = this.props.video.currentTime;
        if (currentTime <= 0) return false;

        const timeBehindLive = this.props.video.duration - currentTime;
        const acceptableDelay = Math.max(2, this.props.avrgBufferDuration - 0.5);
        return (timeBehindLive > (this.props.avrgBufferDuration + acceptableDelay));
    }

    @bind
    tick () {
        const video = this.props.video;
        const currentTime = video.currentTime;

        if (this.state.isSeeking) {
            const step = this.state.playbackRate / this.tickFrequency;
            const end = video.duration - this.props.avrgBufferDuration;
            video.currentTime = Math.max(0, Math.min(end, currentTime + step));
            this.ticksSinceLastSeek = 0;
        } else {
            const timeBehindLive = video.duration - currentTime;
            if (timeBehindLive < (this.props.avrgBufferDuration - 1)) {
                // We have reached the live stream and we want to slow down
                if (this.state.playbackRate !== 1) {
                    this.setVideoPlaybackRate(1);
                }
            }
            this.ticksSinceLastSeek++;
            /* Note: We wait a little after manually seeking before we start fastforwarding to catch up */
            if (this.shouldStartLiveCatchup()) {
                this.catchUpToLive(timeBehindLive);
            }
        }
    }

    beginSeeking () {
        this.props.video.playbackRate = 0;
        this.setState({isSeeking: true});
        Analytics.streamEvent(this.props.stream, "manualseek", {
            type: "scrubber",
        });
    }

    @bind
    endSeeking () {
        this.setState({isSeeking: false});
        this.setVideoPlaybackRate(1);
    }

    dragSeeking (pageX) {
        const elementWidth = this.element.offsetWidth;
        const relativePosition = pageX - this.element.getBoundingClientRect().left;
        const percentage = Math.min(0.964, Math.max(0.036, (relativePosition / elementWidth)));
        const playbackRate = this.calculatePlaybackRate(percentage);

        this.setState({playbackRate: playbackRate});
    }

    @bind
    onTouchStart (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.beginSeeking();
        this.dragSeeking(ev.touches[0].pageX);
    }

    @bind
    onTouchEnd (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.endSeeking();
    }

    @bind
    onTouchMove (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.dragSeeking(ev.touches[0].pageX);
    }

    @bind
    onMouseDown (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.beginSeeking();
        this.dragSeeking(ev.pageX);
        const self = this;
        $(window).on("mousemove", this.onMouseMove);
        $(window).one("mouseup", function () {
            $(window).off("mousemove", self.onMouseMove);
            self.endSeeking();
        });
    }

    @bind
    onMouseMove (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.dragSeeking(ev.pageX);
    }

    render () {
        let playbackRate = this.state.playbackRate;
        if (!this.state.isSeeking && this.props.paused) {
            playbackRate = 0;
        }
        let position = this.calculatePlaybackMarkerPosition(playbackRate);
        let showPlaybackRateLocked = !this.state.autoCatchup && !this.state.isSeeking;

        return (
            <div>
                <div style={{cursor: "pointer", height: this.props.height}}
                    ref={(el) => this.element = el}
                    onMouseDown={this.onMouseDown}
                    onTouchStart={this.onTouchStart}
                    onTouchEnd={this.onTouchEnd}
                    onTouchMove={this.onTouchMove}>
                    <GenericBlackBtn
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "" + (position*100) + "%",
                            bottom: "7px",
                            width: "45px",
                            height: "33px",
                            marginLeft: "-22.5px",
                            marginTop: "-16.5px",
                            zIndex: 2,
                            background: "rgba(0,0,0,0.8)",
                        }} btnClassName="fullwidth">
                        {showPlaybackRateLocked &&
                            <div style={{
                                position: "absolute",
                                top: "-11px",
                                left: "16px",
                                color: "red",
                                fontSize: "16px",
                                lineHeight: 1,
                            }}>
                                <span className="glyphicon glyphicon-lock" />
                            </div>
                        }
                        {playbackRate.toFixed(Math.abs(playbackRate) < 10 ? 1 : 0)}
                    </GenericBlackBtn>
                    <div style={{
                        position: "absolute",
                        width: "100%",
                        height: "2px",
                        left: "0",
                        top: "50%",
                        marginTop: "-1px",
                        backgroundColor: "rgba(255,255,255,0.5)",
                    }} />
                    <div style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        height: "16px",
                        width: "2px",
                        marginLeft: "-1px",
                        marginTop: "-8px",
                        backgroundColor: "rgba(255,255,255,0.5)",
                    }} />
                </div>
                <GenericBlackBtn
                    style={{position: "absolute", zIndex: 1, left: "100%", top: "50%", marginTop: "-16.5px"}}
                    btnClassName="btn"
                    onClick={this.toggleAutoCatchup}>
                    <span className="glyphicon glyphicon-lock" style={{
                        color: this.state.autoCatchup ? "white" : "red",
                    }} />
                </GenericBlackBtn>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/PlaybackRateControls.js